<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex; flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addTax">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="area"
          title="国家/地区"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="taxType"
          title="类型"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="rate"
          title="税率"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="taxDesc"
          title="描述"
          width="80">
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <div class="table-operation-wrap">
              <a-button type="link" @click="editTax(record.id)"> {{ $t('EDIT') || '编辑' }}
              </a-button>
              <a-button type="link" @click="deleteTax(record.id)"> {{ $t('DELETE') || '删除' }}
              </a-button>
            </div>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="税费"
      v-model="form.visible">
      <tax-edit
        v-if="form.visible"
        :tax-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </tax-edit>
    </a-modal>
  </a-card>
</template>

<script>
import { _deleteTax, _queryAllTax } from '@/api/websiteTaxApi';
import TaxEdit from '@/views/website/tax/TaxEdit.vue';

async function getTaxList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryAllTax({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function addTax() {
  this.form.data.id = null;
  this.form.visible = true;
}
function editTax(taxId) {
  this.form.data.id = taxId;
  this.form.visible = true;
}

async function deleteTax(taxId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteTax(taxId);
      if (result) {
        this.$message.success('删除成功');
        await this.getTaxList();
      }
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
}

export default {
  name: 'TaxList',
  components: { TaxEdit },
  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getTaxList,
    addTax,
    editTax,
    deleteTax,
    closeForm,
  },
  created() {
    this.getTaxList();
  },
};
</script>

<style scoped>

</style>
